<template>
<div>
  <section class="content-header">
    <h1>
      学习时长数据
      <small>大声说英语学习数据</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/loudSpeakLearn/learnTime">大声说英语学习数据</a></li>
      <li class="active">学习时长数据</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true" :model="filters">
				<el-form-item>
          <el-select v-model="filters.customer" multiple filterable clearable placeholder="客户名称">
            <el-option
              v-for="item in customers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-select v-model="filters.schoolId" multiple filterable clearable placeholder="School ID">
            <el-option
              v-for="item in customers"
              :key="item.id"
              :label="item.id"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.dateRange" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" :default-value="currentDate" value-format="yyyy-MM-dd">
          </el-date-picker>
				</el-form-item>
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">合作校平均学习时长排行榜</span>
      </div>
      <div class="echart">
        <IEcharts :option="timeRanking" :resizable="true" :loading="loading"></IEcharts>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">合作校平均学习时长分布</span>
      </div>
      <div class="echart">
        <IEcharts :option="timeSpread" :resizable="true" :loading="loading"></IEcharts>
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import {mapGetters} from 'vuex'
import {loadLearnTimeData} from 'api/loud-speak-learn'
import {withRank} from 'common/js/app-utils'
// import {Loading} from 'element-ui'

export default {
  computed: {
    ...mapGetters([
      'customers',
      'pickerOptions',
      'orgTypes'
    ])
  },
  data () {
    return {
      currentDate: new Date(),
      filters: {
        customer: [],
        schoolId: [],
        dateRange: [],
        orgType: ''
      },

      loading: true,
      timeRanking: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '25%', y: '14%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: []
        },
        series: [{
          name: '时长（分钟）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },

      timeSpread: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '15%', y: '14%', width: '70%', height: '75%'},
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: '学校（数目）',
          type: 'bar',
          data: [0, 0, 0, 0]
        }],
        color: ['rgb(91,155,213)']
      }
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this._loadLearnTimeData()
  },
  methods: {
    query () {
      this._loadLearnTimeData(this.filters)
    },
    _loadLearnTimeData () {
      this.loading = true
      loadLearnTimeData(this.filters)
      .then((res) => {
        this.loading = false
        this.timeRanking.yAxis.data = withRank(res.duration_ranking.keys.reverse(), res.duration_ranking.ranks.reverse())
        this.timeRanking.series[0].data = res.duration_ranking.values.reverse()
        this.timeSpread.xAxis.data = res.duration_spread.keys
        this.timeSpread.series[0].data = res.duration_spread.values
      }, (msg) => {
        this.loading = false
        this._resetData()
        this.$message.error(msg)
      })
    },
    _resetData () {
      this.timeRanking.yAxis.data = []
      this.timeRanking.series[0].data = []
      this.timeSpread.xAxis.data = []
      this.timeSpread.series[0].data = []
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
</style>



// WEBPACK FOOTER //
// src/components/voip-details/voip-details.vue